import { capitalize } from 'lodash'
import { useMemo, useState } from 'react'

import {
    BookableDefaultColorKey,
    bookableItemColors,
    employeeColors,
} from '../../utils/calendarColors'
import { SearchableSelect } from '../common/fields/SearchableSelect'

type Props = {
    type: BookableDefaultColorKey | 'employee'
    color: string
    onSelect: (color: string) => void
}

export const CalendarColorSelect = ({ type, color, onSelect }: Props) => {
    const [colorName, setColorName] = useState<string>(color)

    const items = useMemo(() => {
        const colors = type !== 'employee' ? bookableItemColors : employeeColors

        return Object.entries(colors).map(([name, color]) => {
            return {
                id: name,
                title: capitalize(name),
                tertiaryView: (
                    <div
                        className="size-6 rounded-full border-[3px] border-white"
                        style={{ background: color ? color.fg : '#FFFFFF' }}
                    ></div>
                ),
            }
        })
    }, [type])

    return (
        <SearchableSelect
            className="input"
            items={items}
            placeholder="Set calendar color"
            selectedItemID={colorName}
            onSelectItem={(item) => {
                setColorName(item?.id.toString() ?? '')
                onSelect(item?.title.toLowerCase() ?? '')
            }}
            shouldPreserveLastSelection
        />
    )
}
